import styled, { css } from 'styled-components';

export type SeparatorProps = {
  $block: boolean;
  $orientation: 'horizontal' | 'vertical';
};

export const Separator = styled.div<SeparatorProps>`
  display: ${({ $block }) => ($block ? 'block' : 'flex')};
  background-color: ${({ theme }) => theme.colors.neutral.neutral_alpha[6]};
  ${({ $block, $orientation }) => {
    if ($block) {
      return css`
        width: ${$orientation === 'horizontal' ? '100vw' : '1px'};
        height: ${$orientation === 'horizontal' ? '1px' : '100vh'};
      `;
    }

    if ($orientation === 'horizontal')
      return css`
        height: 1px;
        width: 100%;
      `;
    return css`
      width: 1px;
      height: 100%;
    `;
  }}
`;
